import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
export function PostAlert(alertType, message) {
  let newAlert = {
    alertType,
    message
  };
  dispatcher.dispatch({
    actionType: actionTypes.AlertAdd,
    Result: newAlert
  });
}
export function RemoveAlert(id) {
  console.log("AlertDelete");
  dispatcher.dispatch({
    actionType: actionTypes.AlertDelete,
    Result: id
  });
}
